import { Color } from '../constants';
import PageWrap from './PageWrap';
import { TicketDetailSkeleton, TicketsListSkeleton } from './skeletons';

type Variant = 'tickets-list' | 'ticket-detail';

type Props = {
  variant: Variant;
};

const LIMIT_WIDTH: Record<Variant, 'large' | undefined> = {
  'tickets-list': 'large',
  'ticket-detail': undefined,
};

/** Shell wrapper for one of the bespoke screen skeletons. */
export default function PageSkeleton({ variant }: Props) {
  return (
    <PageWrap
      background={Color.neutral5}
      noPadding
      limitWidth={LIMIT_WIDTH[variant]}
    >
      {variant === 'tickets-list' ? (
        <TicketsListSkeleton />
      ) : (
        <TicketDetailSkeleton />
      )}
    </PageWrap>
  );
}
